import { AfterViewInit, Component, EventEmitter, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { TranslateService } from "@ngx-translate/core";
import { Location } from "@angular/common";
@Component({
  selector: "app-confirm-box",
  templateUrl: "./confirm-box.component.html",
  styleUrls: ["./confirm-box.component.scss"],
  standalone: false,
})
export class ConfirmBoxComponent implements OnInit, AfterViewInit {
  confirmText: string;
  acceptButtonText = "Yes";
  cancleButtonText = "No";
  title: string;
  callback: EventEmitter<any> = new EventEmitter();

  constructor(
    public modalRef: BsModalRef,
    public translation: TranslateService,
    private location: Location,
  ) {
    this.location.subscribe((popStateEvent) => {
      if (this.modalRef) {
        this.modalRef.hide();
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      document
        .getElementsByClassName("modal")[0]
        .classList.add("rounded_corner");
    }, 0);
  }

  ngOnInit() {}

  choice(bool: boolean): void {
    this.callback.emit(bool);
    this.modalRef.hide();
  }
}
